<template>
	<CModal
		title="Confirmation"
		:show.sync="enableModal"
		class="disable-footer disable-header"
		centered
		fade
		:closeOnBackdrop="false"
		@close="handleClose"
	>
		<div class="popup-header">
			<h5 class="modal-title">Confirmation</h5>
			<button type="button" @click="handleClose">
				<CIcon name="cil-x" />
			</button>
		</div>
		<br />
		<center>
			Are you sure you want to {{ type }} ?
			<div class="inactive-modal-response">
				<CButton
					type="submit"
					color="primary"
					class="m-1"
					@click="handleOperation"
					>Yes</CButton
				>
				<CButton
					type="submit"
					color="secondary"
					class="m-1"
					@click="handleClose"
					>No</CButton
				>
			</div>
		</center>
	</CModal>
</template>

<script>
export default {
	data() {
		return {
			enableModal: false,
		};
	},
	props: {
		modal: Boolean,
		type: String,
		handleOperation: [Function, Promise],
	},
	watch: {
		modal() {
			this.enableModal = this.modal;
		},
	},
	methods: {
		handleClose() {
			console.log("close");
			this.enableModal = false;
			this.$emit("close");
		},
	},
	mounted() {
		document
			.getElementsByClassName("close")[0]
			.addEventListener("click", () => {
				console.log("close");
				this.enableModal = false;
				this.$emit("close");
			});
	},
};
</script>